import React, { useState } from 'react';
import clsx from 'clsx';

import { Transition } from 'react-transition-group';

import {
    IconButton,
    Tooltip,
    Zoom,
    colors
} from '@material-ui/core';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        display: "inline-flex",
        alignContent: "center",
        justifyContent: "center",
        transition: "width 200ms ease-in-out"
    },
    dangerousButton: {
        color: colors.red[500]
    },
    confirmButton: {
        color: colors.green[500]
    },
}));

const transitionStyles = {
    entering: { width: "100px" },
    entered: { width: "100px" },
    exiting: { width: "48px" },
    exited: { width: "48px" },
};

export const ConfirmIconButton = ({
    icon,
    tooltip,
    confirmTooltip,
    cancelTooltip,
    dangerous,
    vertical,
    disabled,
    onClick,
    ...props }) => {

    const classes = useStyles();

    const [askConfirm, setAskConfirm] = useState(false);

    const onConfirmClick = (e) => {
        setAskConfirm(false);
        if (onClick) onClick(e);
    }

    return (
        <Transition in={askConfirm} timeout={200}>
            {state =>
                <div
                    className={clsx(classes.root, props.className)}
                    style={{ ...transitionStyles[state] }}>
                    <Zoom
                        mountOnEnter
                        unmountOnExit
                        in={!askConfirm}
                        timeout={{ appear: 300, enter: 300, exit: 0 }} >
                        <Tooltip title={tooltip}>
                            <span>
                                <IconButton
                                    className={dangerous ? classes.dangerousButton : classes.actionButton}
                                    aria-label={tooltip}
                                    disabled={disabled}
                                    onClick={() => setAskConfirm(!askConfirm)}>
                                    {icon}
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Zoom>
                    <Zoom
                        mountOnEnter
                        unmountOnExit
                        in={askConfirm}
                        timeout={{ appear: 300, enter: 300, exit: 0 }}>
                        <Tooltip title={confirmTooltip || "confirm"}>
                            <span>
                                <IconButton
                                    className={classes.confirmButton}
                                    aria-label={confirmTooltip || "confirm"}
                                    disabled={disabled}
                                    onClick={onConfirmClick}>
                                    <CheckIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Zoom>
                    <Zoom
                        mountOnEnter
                        unmountOnExit
                        in={askConfirm}
                        timeout={{ appear: 300, enter: 300, exit: 0 }}>
                        <Tooltip title={cancelTooltip || "cancel"}>
                            <span>
                                <IconButton
                                    aria-label={cancelTooltip || "cancel"}
                                    disabled={disabled}
                                    onClick={() => setAskConfirm(false)}>
                                    <CloseIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Zoom>
                </div>
            }
        </Transition>
    );
}